import { schema } from 'normalizr';

// this beauty splits up our JSON objects so that embedded
// activities within a company get pulled out to their own entities

// good documentation right here:
// https://github.com/paularmstrong/normalizr

const activity = new schema.Entity('activities', { idAttribute: 'id' });
const note = new schema.Entity('notes', { idAttribute: 'id' });
const project = new schema.Entity('projects', { idAttribute: 'id' });
const task = new schema.Entity('tasks', { idAttribute: 'id' });
const person = new schema.Entity('persons', { idAttribute: 'id' });
const file = new schema.Entity('files', { idAttribute: 'id' });
const company = new schema.Entity('companies', { idAttribute: 'id' });
const staff = new schema.Entity('staffs', { idAttribute: 'id' });
const notification = new schema.Entity('notifications', { idAttribute: 'id' });
const serviceKey = new schema.Entity('serviceKeys', { idAttribute: 'id' });
const serviceType = new schema.Entity('serviceTypes', { idAttribute: 'id' });
const numberRange = new schema.Entity('numberRanges', { idAttribute: 'id' });
const objectNumber = new schema.Entity('objectNumber', { idAttribute: 'id' });
const settings = new schema.Entity('settings', { idAttribute: 'key' });
const profilesettings = new schema.Entity('profilesettings', {
  idAttribute: 'key',
});

company.define({
  projects: [project],
  tasks: [task],
  activities: [activity],
  activities_involved: [activity],
  persons: [person],
  staff: [staff],
  files: [file],
});

activity.define({
  project,
  tasks: [task],
  company,
  responsible_user: staff,
  companies: [company],
  persons: [person],
  staff: [staff],
  files: [file],
});

note.define({
  user_id: staff,
});

project.define({
  company,
  leader: staff,
  tasks: [task],
  activities: [activity],
  // persons: [person],
  // staff: [staff],
  files: [file],
});

person.define({
  // companies: [company],
  tasks: [task],
  activities: [activity],
  files: [file],
});

staff.define({
  companies: [company],
  tasks: [task],
  activities: [activity],
  files: [file],
});

task.define({
  companies: [company],
  tasks: [task],
  activities: [activity],
  files: [file],
});

serviceKey.define({
  types: [serviceType],
});

serviceType.define({});

numberRange.define({
  objectNumbers: [objectNumber],
});

objectNumber.define({
  NumberRange: [numberRange],
});

settings.define({});

profilesettings.define({});

notification.define({});

export {
  activity,
  project,
  task,
  person,
  file,
  company,
  staff,
  note,
  serviceKey,
  serviceType,
  numberRange,
  objectNumber,
  notification,
  settings,
  profilesettings,
};



// WEBPACK FOOTER //
// ./src/store/modules/schemas.js